import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { CheckCircle2, ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-peach-50/50 px-4 relative overflow-hidden" data-id="element-89">
      {/* Background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-90">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-white rounded-full blur-3xl opacity-60" data-id="element-91"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-92">
        <div className="text-center mb-16" data-id="element-93">
          <h2 className="text-3xl md:text-5xl font-bold text-warm-gray mb-6" data-id="element-94">
            Tu nueva vida financiera 💰💸✨ te espera
          </h2>
          <p className="text-xl text-warm-800 max-w-2xl mx-auto" data-id="element-95">
            El valor real del contenido es{' '}
            <span className="line-through text-terracotta-300 decoration-2" data-id="element-96">
              $100
            </span>
            , pero hoy puedes empezar tu transformación por menos de lo que
            cuesta una salida a comer.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] shadow-warm-xl overflow-hidden border border-peach-100 relative" data-id="element-97">
          {/* Ribbon */}
          <div className="absolute top-0 right-0 bg-coral-500 text-white text-xs font-bold px-10 py-2 transform rotate-45 translate-x-10 translate-y-6 shadow-md z-10 tracking-widest" data-id="element-98">
            OFERTA LIMITADA
          </div>

          <div className="p-10 md:p-16 text-center" data-id="element-99">
            <h3 className="text-3xl font-bold text-warm-gray mb-3" data-id="element-100">
              Pack Transformación Total
            </h3>
            <p className="text-terracotta-600 mb-10 font-medium" data-id="element-101">
              Ebook Completo + Plantilla de Regalo
            </p>

            <div className="flex items-center justify-center mb-10 bg-cream-50 inline-flex px-8 py-6 rounded-3xl border border-peach-50 mx-auto" data-id="element-102">
              <span className="text-7xl font-bold text-warm-gray tracking-tighter" data-id="element-103">
                $9.97
              </span>
              <span className="ml-4 text-warm-600 text-lg text-left leading-tight font-medium" data-id="element-104">
                Pago
                <br data-id="element-105" />
                Único
              </span>
            </div>

            <div className="space-y-5 mb-12 text-left max-w-md mx-auto" data-id="element-106">
              <div className="flex items-center text-warm-800 p-3 rounded-xl hover:bg-peach-50 transition-colors" data-id="element-107">
                <CheckCircle2 className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-108" />
                <span className="text-lg" data-id="element-109">
                  Ebook "Transforma tus Finanzas en 30 días"
                </span>
              </div>
              <div className="flex items-center text-warm-800 p-3 rounded-xl hover:bg-peach-50 transition-colors bg-peach-50/50" data-id="element-110">
                <CheckCircle2 className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-111" />
                <span className="text-lg" data-id="element-112">
                  <span className="font-bold text-coral-600" data-id="element-113">BONO:</span>{' '}
                  Plantilla Automatizada ($14.99 valor)
                </span>
              </div>
              <div className="flex items-center text-warm-800 p-3 rounded-xl hover:bg-peach-50 transition-colors" data-id="element-114">
                <CheckCircle2 className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-115" />
                <span className="text-lg" data-id="element-116">Acceso inmediato y de por vida</span>
              </div>
              <div className="flex items-center text-warm-800 p-3 rounded-xl hover:bg-peach-50 transition-colors" data-id="element-117">
                <CheckCircle2 className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-118" />
                <span className="text-lg" data-id="element-119">
                  Actualizaciones futuras gratuitas
                </span>
              </div>
            </div>

            <CTAButton fullWidth className="mb-8 text-xl py-5" href="https://pay.hotmart.com/L103560259C" data-id="element-120">
              🚀 Quiero empezar mi cambio - $9.97 💰
            </CTAButton>

            <p className="text-sm text-warm-600 mb-10 font-medium" data-id="element-121">
              Clic → Descarga → Empiezas hoy. Sin esperas. Sin complicaciones.
            </p>

            <div className="flex flex-wrap justify-center gap-3 text-sm text-warm-700 border-t border-peach-100 pt-10" data-id="element-122">
              <div className="flex items-center justify-center bg-cream-50 py-3 px-4 rounded-xl" data-id="element-123">
                <span className="mr-2" data-id="element-124">👉</span> No esperes al "después"
              </div>
              <div className="flex items-center justify-center bg-cream-50 py-3 px-4 rounded-xl" data-id="element-125">
                <span className="mr-2" data-id="element-126">👉</span> No esperes a "ganar más"
              </div>
              <div className="flex items-center justify-center bg-cream-50 py-3 px-4 rounded-xl" data-id="element-127">
                <span className="mr-2" data-id="element-128">👉</span> Tu cambio empieza hoy
              </div>
            </div>
          </div>

          <div className="bg-warm-gray p-5 text-center text-sm text-cream-100 flex items-center justify-center gap-3" data-id="element-129">
            <Lock className="w-4 h-4 text-green-400" data-id="element-130" />
            <span className="font-medium tracking-wide" data-id="element-131">
              Compra 100% Segura
            </span>
            <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-132" />
          </div>
        </motion.div>

        <div className="mt-16 text-center" data-id="element-133">
          <p className="text-2xl font-medium text-warm-gray" data-id="element-134">
            Esa paz financiera NO es un sueño. Es un sistema. <br data-id="element-135" />
            <span className="text-coral-600 font-bold relative inline-block mt-2" data-id="element-136">
              Y este eBook te lo da.
              <svg className="absolute w-full h-3 -bottom-2 left-0 text-peach-300" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-137">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="none" data-id="element-138" />
              </svg>
            </span>
          </p>
        </div>
      </div>
    </section>;
}